import React, { useState } from 'react'
import SceneExplore from '../../models/SceneExplore/SceneExplore.js'
import SingleSelect from '../../models/SingleSelect/SingleSelectInterrogate.js'

import './InterrogateSources.scss'
import Popup from '../../partials/Popup/Popup.js'

const InterrogateSources = props => {

    const data = props.data;
    const [questionIndex, setQuestionIndex] = useState(-1);
    const [introOpen, setIntroOpen] = useState(!!props.data.intro);
    const [resetScene, setResetScene] = useState(false);
    const [qscrim, setQscrim] = useState(false);
    const [delayValue, setDelayValue] = useState(1);

    const handleQuestionComplete = () => {
        if(qscrim) setQscrim(false);

        if (questionIndex + 1 >= data.questions.length) {
            //last question
            props.onComplete();
        } else {
            setQuestionIndex(questionIndex + 1)
        }
    }

    const onSceneChange = (hasBeenClickedArray, selectedIndex) => {
        if (((hasBeenClickedArray.filter(el => el).length > 0 && selectedIndex === -1) || (hasBeenClickedArray.filter(el => el).length > 1) ) && questionIndex === -1) {
            //at least 1 thing has been clicked
            setQuestionIndex(0)
        }
    }

    //hacky temp fix for close popup to animate properly on close
    setTimeout(() => {
        setDelayValue(0)
    }, 2000);
 
    return (
        <div className={`InterrogateSources`}>
           
            <div className="context">
                <div className={`heading`} dangerouslySetInnerHTML={{__html:data.heading}}></div>
                {!introOpen && <div className={`instructions`} dangerouslySetInnerHTML={{__html:data.instructions}}></div>}
            </div>

            {
                data.scene &&
                <SceneExplore
                    data={data.scene}
                    introOpen={introOpen}
                    onChange={onSceneChange}
                    resetScene={resetScene}
                />
            }

            {
                qscrim &&
                <div className={`qscrim`}></div>
            }

            {
                data.questions[questionIndex] &&
                <SingleSelect
                    data={data.questions[questionIndex]}
                    onComplete={handleQuestionComplete}
                    key={`question-${questionIndex}`}
                    onChange={(idx)=>{
                        setResetScene(!resetScene)
                        setQscrim(idx !== -1)
                    }}
                />
            }

            {introOpen && <Popup data={data.intro} style={{animationDelay: `${delayValue}s`}}
              onClose={()=> setIntroOpen(false)}/>}
        </div>
    )
}

export default InterrogateSources